import { render, staticRenderFns } from "./PaginationButton.vue?vue&type=template&id=7d4d9db2&scoped=true"
import script from "./PaginationButton.vue?vue&type=script&lang=js"
export * from "./PaginationButton.vue?vue&type=script&lang=js"
import style0 from "./PaginationButton.vue?vue&type=style&index=0&id=7d4d9db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4d9db2",
  null
  
)

export default component.exports